// extracted by mini-css-extract-plugin
export default {"card":"Productcard_card__-gtHx","title":"Productcard_title__ydB66","card1":"Productcard_card1__iDzni","card2":"Productcard_card2__e-ucE"};